<div class="page-layout blank p-12 w-full" fusePerfectScrollbar>
    <h1>Ficha de Cadastro</h1>
    <form [formGroup]="patientForm" name="pacienteform">

        <div fxLayout="row">
            <!-- input Paciente -->
            <mat-form-field class="w-75-p mr-8" appearance="outline">
                <mat-label>Paciente</mat-label>
                <input id="paciente" type="text" placeholder="Nome" formControlName="nomePaciente" aria-label="Nome" required
                    matInput />
                <br>
                    <mat-error *ngIf="patientForm.get('nomePaciente').hasError('required')">
                        O campo é obrigatório
                    </mat-error>
            </mat-form-field>

            <!-- input Data Nascimento-->
            <mat-form-field class="w-25-p" appearance="outline" required>
                <mat-label>Data Nascimento</mat-label>
                <input id="dataNascimento" matInput placeholder="Data Nascimento" formControlName="dataNascimento" required
                    [dropSpecialCharacters]="false" mask="d0/M0/0000">
                <br>
                    <mat-error *ngIf="patientForm.get('dataNascimento').hasError('required')">
                        O campo é obrigatório
                    </mat-error>
            </mat-form-field>

        </div>

        <div class="row" fxLayoutGap="10px">

            <!-- input cpf-->
            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>CPF</mat-label>
                <input matInput placeholder="CPF" formControlName="cpf" mask="000.000.000-00" required>
                <br>
                <mat-error *ngIf="patientForm.get('dataNascimento').hasError('required')">
                    O campo é obrigatório
                </mat-error>
            </mat-form-field>

            <!-- input eg-->
            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>RG</mat-label>
                <input matInput placeholder="RG" formControlName="rg" mask="00.000.000-00">
            </mat-form-field>

        </div>

        <!-- input Email-->
        <mat-form-field class="w-100-p" appearance="outline">
            <mat-label>E-mail</mat-label>
            <input matInput placeholder="Email" formControlName="eMail" type="email">
        </mat-form-field>

        <div class="row" fxLayoutGap="10px">
            <!-- Input Celular -->
            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>Celular</mat-label>
                <input matInput placeholder="Celular" formControlName="telefoneCelular" mask="00 0 0000-0000" required
                    [hiddenInput]="true">

                    <mat-error *ngIf="patientForm.get('dataNascimento').hasError('required')">
                        O campo é obrigatório
                    </mat-error>
            </mat-form-field>

            <!-- input Telefone-->
            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>Telefone</mat-label>
                <input matInput placeholder="Telefone" formControlName="telefone" mask="0000-0000" [hiddenInput]="true">
            </mat-form-field>
        </div>

        <!-- Input mae -->
        <mat-form-field class="w-100-p" appearance="outline">
            <mat-label>Nome da Mãe</mat-label>
            <input matInput placeholder="Nome da mãe" formControlName="nomeMae">
        </mat-form-field>

        <div class="row" fxLayoutGap="10px">
            <!-- input Prontuario -->
            <mat-form-field *ngIf="disabled == true" fxFlex="33" appearance="outline">
                <mat-label>Prontuário</mat-label>
                <input id="prontuario" type="text" placeholder="Prontuário" formControlName="prontuario"
                    aria-label="Nome" matInput />
            </mat-form-field>

            <!-- input Data Raça-->
            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>Raça</mat-label>
                <mat-select formControlName="racaPaciente">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let raca of race" [value]="raca.descricaoRaca">
                        {{raca.descricaoRaca}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- input Data sexo-->
            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>Sexo</mat-label>
                <mat-select formControlName="sexo">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let sexo of gender" [value]="sexo.sexo">
                        {{sexo.sexo}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>


        <div class="row" fxLayoutGap="10px">
            <!-- input nacionalidade-->
            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>Nacionalidade</mat-label>
                <mat-select formControlName="nacionalidade">
                    <mat-option *ngFor="let nationality of nationality" [value]="nationality.nomeNacao">
                        {{nationality.nomeNacao}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- input Data estadoCivil-->
            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>Estado Civil</mat-label>
                <mat-select formControlName="estadoCivil">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let status of civilStatus" [value]="status.estadoCivil">
                        {{status.estadoCivil}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="row" fxLayoutGap="10px">

            <!-- input Data cep-->
            <mat-form-field fxFlex="34" appearance="outline" required>
                <mat-label>CEP</mat-label>
                <input matInput placeholder="CEP" formControlName="cep">
                <button *ngIf="this.patientForm.controls['cep'].value" matSuffix mat-icon-button
                    aria-label="Buscar Cep" (click)="buscarCep()">
                    <mat-icon>search</mat-icon>
                </button>
            </mat-form-field> 

            <!-- input Data bairro-->
            <mat-form-field fxFlex="33" appearance="outline" required>
                <mat-label>Bairro</mat-label>
                <input id="bairro" matInput placeholder="Bairro" formControlName="bairro">
            </mat-form-field>

            <!-- input Data Complemento-->
            <mat-form-field fxFlex="33" appearance="outline" required>
                <mat-label>Complemento</mat-label>
                <input id="bairro" matInput formControlName="complemento">
            </mat-form-field>

        </div>

        <div class="row" fxLayoutGap="10px">

            <!-- input Lagradouro -->
            <mat-form-field fxFlex="70" appearance="outline">
                <mat-label>Lagradouro</mat-label>
                <input id="lagradouro" matInput type="text" placeholder="Lagradouro" formControlName="logradouro"
                    aria-label="Nome" />
            </mat-form-field>

            <!-- input Data uf-->
            <mat-form-field fxFlex="30" appearance="outline" required>
                <mat-label>UF</mat-label>
                <input matInput placeholder="UF" formControlName="uf">
            </mat-form-field>

        </div>

        <div class="row" fxLayoutGap="10px">

            <!-- input  numero lagradouro-->
            <mat-form-field fxFlex="34" appearance="outline" required>
                <mat-label>Número </mat-label>
                <input id="numeroLogradouro" matInput placeholder="Numero" formControlName="numeroLogradouro">
            </mat-form-field>

            <!-- input  municipio-->
            <mat-form-field fxFlex="33" appearance="outline" required>
                <mat-label>Município</mat-label>
                <input matInput placeholder="Munincípio" formControlName="municipio">
            </mat-form-field>

            <!-- input  codigoIBGE-->
            <mat-form-field fxFlex="33" appearance="outline" required>
                <mat-label>Código IBGE</mat-label>
                <input matInput placeholder="Código IBGE" formControlName="codigoIBGE">
            </mat-form-field>

        </div>

        <div class="row" fxLayoutGap="10px">

            <!-- input CONVENIO-->
            <mat-form-field fxFlex="50" appearance="outline">
                <mat-label>Convênio </mat-label>
                <input type="text" placeholder="Nome" [formControl]='insuranceControl' matInput required
                    [matAutocomplete]="autoInsurance" />
                    <mat-error *ngIf="patientForm.get('dataNascimento').hasError('required')">
                        O campo é obrigatório
                    </mat-error>
                <mat-autocomplete #autoInsurance="matAutocomplete" [displayWith]="displayInsurance">
                    <mat-option *ngFor="let insurance of convenio " [value]="insurance">
                        {{ insurance.nomeConvenio }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <!-- input carteira-->
            <mat-form-field fxFlex="50" appearance="outline" required>
                <mat-label>Número da Carteira</mat-label>
                <input matInput formControlName="carteiraConvenio">
            </mat-form-field>

        </div>

        <div class="row" fxLayoutGap="10px">

             <!-- input carteira-->
             <mat-form-field fxFlex="50" appearance="outline" required>
                <mat-label>Validade da Carteira</mat-label>
                <input matInput formControlName="validadeCarteiraConvenio" [dropSpecialCharacters]="false"
                    mask="d0/M0/0000">
            </mat-form-field>

            <!-- input situacao-->
            <mat-form-field *ngIf="disabled == true" fxFlex="50" appearance="outline" required>
                <mat-label>Situação</mat-label>
                <input matInput formControlName="situacao">
            </mat-form-field>

        </div>


    </form>

    <div class="row" fxLayoutGap="10px">

        <button fxFlex="25" (click)="onSubmit()"
            mat-raised-button color="primary">
            <mat-icon>save</mat-icon>
            Salvar
        </button>
        

        <button fxFlex="25" (click)="navigate()" mat-stroked-button color="warn"
            class="md:mt-0 mt-3">
            <mat-icon>cancel</mat-icon>
            Cancelar
        </button>



    </div>
</div>